// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import qs from 'qs'
import ElementUI from 'element-ui'
// import Vconsole from 'vconsole'
import './assets/css/reset.css'
import './assets/css/global.less'
import './assets/iconfont/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'mavon-editor/dist/css/index.css'
import 'vant/lib/popup/style'
import 'vant/lib/pagination/style'
import { Popup, Cell, Pagination } from 'vant'
// import develop from './util/config'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
axios.defaults.baseURL = window.location.protocol.includes('file') ? `https://www.chiens.cn/blog` : `${window.location.protocol}//${window.location.hostname}/blog` // https://www.chiens.cn/blog ${window.location.protocol}//${window.location.hostname}/blog
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Popup)
Vue.use(Cell)
Vue.use(Pagination)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js